import { startTransition, useEffect } from "react";
import { useParams } from "react-router-dom";

import i18next from "i18next";

import { useActiveLanguages } from "../store/languages/language.selectors";

import { useContent } from "./use-content";
import { useDispatchedActions } from "./use-dispatch-actions";
import { useMatchRoute } from "./use-match-route";

export const usePageContent = () => {
  const tag = useMatchRoute()?.tag;

  const { lang } = useParams();
  const { getPageContent } = useDispatchedActions();
  const { locales } = useActiveLanguages();
  const { store } = useContent();

  const locale = lang || i18next.language;

  useEffect(() => {
    if (tag === "article") return;

    if (!locale || !locales.includes(locale)) {
      return;
    }

    if (!store?.[tag]?.hasOwnProperty(locale)) {
      startTransition(() => getPageContent({ tag, languageCode: locale }));
    }
  }, [locale, tag]);
};
